import React from 'react';
import classNames from 'classnames';

import { Member } from '@wix/members-domain-ts';

import styles from './picture.scss';
import Avatar from '../../avatar';
import { Button } from '../../button';

export interface Props {
  member: Member;
  pictureStyle: number;
  goToMemberPage: (id: string) => void;
}

export const Picture: React.StatelessComponent<Props> = ({ member, goToMemberPage, pictureStyle }) => (
  <Button className={styles.pictureCont} onClick={() => goToMemberPage(member.uid)} tabIndex={-1}>
    <Avatar
      dataHook="ff-card-members-avatar"
      url={member.picture}
      layoutType={pictureStyle}
      className={classNames(styles.avatar, 'ma-avatar-outer-border')}
      name={member.name}
      isMobile={false}
    />
  </Button>
);
